import * as THREE from 'three';

export const make3DModelTransparentAndRed = (model: THREE.Group<THREE.Object3DEventMap> | THREE.Object3D | THREE.Mesh, opacity = 0.6) => {
    model.traverse(object => {
        if (object.material) {
            (object.material as THREE.Material).transparent = true;
            (object.material as THREE.Material).opacity = opacity;
            if (object.material.color) object.material.color = new THREE.Color('red');
        }
    });
};